import closeSvg from "../../../../assets/svg/POSTER/close.svg";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import "../../scheduling-linear-new/components/adsInfo.scss";

const AssetDuration = ({ label, duration }) => (
    <h6 className="mx-2 py-1 px-2" style={{fontSize: ".875rem", background: "#FFFFFF1F", borderRadius: "15px"}}><span className="fw-normal">{label}</span> - {duration}</h6>
);

const AssetInfoCard = ({ 
    assetInfo,
    millisecondsToHuman,
    appTheme,
    categoryTab,
    viewType,
    formatTime
 }) => {
    const formatDuration = (type) => {
        // return assetInfo ? millisecondsToHuman(
        //     assetInfo?.adBreaks?.filter(data => (data?.assetType === type || data?.type === "filler"))
        //         ?.reduce((total, ad) => total + ad.durationInMillis? ad.durationInMillis : ad.duration, 0)
        // ) : "00:00:00";
        if (!assetInfo) return "00:00:00";

        const filteredAds = assetInfo?.adBreaks?.filter(
            (data) => data?.assetType === type || data?.type === type.toLowerCase()
        );

        const totalDuration = filteredAds?.reduce(
            (total, ad) => total + (ad?.durationInMillis ?? ad?.duration ?? 0),
            0
        );

        return millisecondsToHuman(totalDuration);
    };

    return (
        <div className={`top-content-right ${appTheme === "light" ? "rounded shadow-sm" : ""}`}>
            <div className="left-side d-flex align-items-center justify-content-between">
                <h5 className="py-3 px-3 my-1">{assetInfo?.title}</h5>
                {/* <a className="btn-circle mx-3 mb-1" style={{ borderRadius: "3px" }}>
                    <img src={closeSvg} width={16}/>
                </a> */}
            </div>
            <div className="asset-duration-cont row px-1 pb-2 align-items-center">
                <div className="col-5 start-end-time">
                    <h6 className={`px-2 mx-1 ${viewType === "expandView" && "d-flex"}`}>
                        {
                            viewType === "expandView" && assetInfo ?
                            <>
                                <TimePicker
                                    value={formatTime(assetInfo?.startAt)}
                                    hourPlaceholder="HH"
                                    minutePlaceholder="mm"
                                    secondPlaceholder="ss"
                                    maxDetail="second"
                                    format="HH:mm:ss"
                                    disableClock={true}
                                    // disabled={editDisable}
                                    // onChange={(e) => {
                                    //     setProgramTime(e, assetInfo?.uuid, assetInfo?.sequence, assetInfo?.panelDate);
                                    // }}
                                />
                                -
                                <TimePicker
                                    value={formatTime(assetInfo?.endAt)}
                                    hourPlaceholder="HH"
                                    minutePlaceholder="mm"
                                    secondPlaceholder="ss"
                                    maxDetail="second"
                                    format="HH:mm:ss"
                                    disableClock={true}
                                    disabled={true}
                                    style={{background: "#000"}}
                                />
                            </>
                            :
                            assetInfo ? `${millisecondsToHuman(assetInfo?.scheduleStartTime)} - ${millisecondsToHuman(assetInfo?.scheduleEndTime)}` : "00:00:00 - 00:00:00"
                        }
                    </h6>
                </div>
                <div className="col-7 d-flex video-ads-time justify-content-end">
                    <h6 className="me-2 py-1 px-2" style={{fontSize: ".875rem", background: "#FFFFFF1F", borderRadius: "15px"}}><span className="fw-normal">Video</span> - {assetInfo ? millisecondsToHuman(assetInfo?.durationInMillis ? assetInfo?.durationInMillis : assetInfo?.duration) : "00:00:00"}</h6>
                    {categoryTab === "Ads" && <AssetDuration label="Ads" 
                        // duration={formatDuration("AD")} 
                        duration={formatDuration("FILLER")} 
                    />}
                    {categoryTab === "Promos" && <AssetDuration label="Pro" duration={formatDuration("PROMO")} />}
                    {categoryTab === "Secondary" && <AssetDuration label="Sec" 
                        // duration={formatDuration("FILLER")} 
                        duration={formatDuration("SECONDARY")} 
                    />}
                </div>
            </div>
        </div>
    );
};

export default AssetInfoCard;
